import Raven from 'raven-js';
import { removeSubscriptionIfStale } from './subscription/removeSubscriptionIfStale';
import { debug } from '../../utils/DebugUtil';
import { subscribeToPushNotifications } from './subscription/subscribeToPushNotifications';
import { getPushSubscriptionOptions } from './subscription/getPushSubscriptionOptions';
export const startPushNotificationSubscription = async registration => {
  // Old Safari versions do not have the standard push manager
  if (!registration.pushManager) {
    return false;
  }
  try {
    const existingSubscription = await registration.pushManager.getSubscription();
    const wasStale = await removeSubscriptionIfStale(existingSubscription);
    if (wasStale) {
      const pushSubscription = await registration.pushManager.subscribe(getPushSubscriptionOptions());
      await subscribeToPushNotifications(pushSubscription);
      debug('service worker is subscribed to push events');
    }
  } catch (error) {
    if (error instanceof DOMException) {
      if (error.name === 'AbortError' || error.name === 'InvalidStateError' || error.name === 'NotAllowedError') {
        debug(`failed to subscribe to push notifications: ${error.name}`, error);
        return false;
      }
    }
    Raven.captureBreadcrumb({
      message: 'Failed to setup push notification subscriptions with an unhandled error'
    });
    debug('Failed to setup push notification subscriptions: ', error);
    throw error;
  }
  return true;
};